import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import Noise from 'src/assets/images/campaigns/noise.png'

const useStyles = makeStyles()((theme) => ({
  matrixBox: {
    background: `url(${Noise.src}) #A0C0E9`,

    borderRadius: '60px',
    maxWidth: theme.maxWidth,
    margin: 'auto',
    position: 'relative',
    zIndex: '222',
  },

  pressCenter: {
    height: 'auto',
    textAlign: 'center',
    background: `url(${Noise.src})`,
    maxWidth: theme.maxWidth,
    margin: 'auto',
    borderRadius: '60px',
    padding: theme.spacing(0, 0, 30),

    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      borderRadius: '40px',
    },
  },

  pressCenterContent: {
    width: '70%',
    margin: 'auto',
    padding: theme.spacing(32, 0, 24),
    marginTop: '-3rem',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: theme.spacing(22, 4, 24),
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '72px',
    textAlign: 'center',
    lineHeight: '83px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    // padding: theme.spacing(3, 0, 2),
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
      lineHeight: '43px',
    },
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: '24px',
    color: theme.custom.blackColor,
    padding: theme.spacing(4, 0, 0),
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      padding: theme.spacing(2, 0, 0),
      lineHeight: '17px',
    },
  },
  zenModeWithBg: {
    backgroundImage: `none`,
    background: `none`,
  },
}))

export default useStyles
